export type SupportedLanguage = 'en' | 'am' | 'om' | string;

export function localeForLanguage(language: SupportedLanguage): string {
  if (language === 'am') {
    return 'am-ET';
  }
  if (language === 'om') {
    return 'om-ET';
  }
  return 'en-ET';
}

export function formatCurrency(value: number | null | undefined, language: SupportedLanguage = 'en'): string {
  return new Intl.NumberFormat(localeForLanguage(language), {
    style: 'currency',
    currency: 'ETB',
    maximumFractionDigits: 2,
  }).format(value ?? 0);
}
